module.exports = __webpack_public_path__ + "img/exam (4).ff53fe72.png";